/**
 * Ludo Board Coordinate System (15x15 Grid)
 * Each cell is 1 unit. Total 15x15 units.
 * Percentages = (cell / 15) * 100
 */

export const BOARD_SIZE = 15;

// Main track (52 squares) mapped to [x, y] on a 15x15 grid
// Each coord now has +0.5 added to center it in the cell
export const TRACK_COORDS = [
    [1.5, 6.5], [2.5, 6.5], [3.5, 6.5], [4.5, 6.5], [5.5, 6.5], // Red start area
    [6.5, 5.5], [6.5, 4.5], [6.5, 3.5], [6.5, 2.5], [6.5, 1.5], [6.5, 0.5], // Top-left up
    [7.5, 0.5], // Top center
    [8.5, 0.5], [8.5, 1.5], [8.5, 2.5], [8.5, 3.5], [8.5, 4.5], [8.5, 5.5], // Top-right down
    [9.5, 6.5], [10.5, 6.5], [11.5, 6.5], [12.5, 6.5], [13.5, 6.5], [14.5, 6.5], // Right top
    [14.5, 7.5], // Right center
    [14.5, 8.5], [13.5, 8.5], [12.5, 8.5], [11.5, 8.5], [10.5, 8.5], [9.5, 8.5], // Right bottom
    [8.5, 9.5], [8.5, 10.5], [8.5, 11.5], [8.5, 12.5], [8.5, 13.5], [8.5, 14.5], // Bottom-right down
    [7.5, 14.5], // Bottom center
    [6.5, 14.5], [6.5, 13.5], [6.5, 12.5], [6.5, 11.5], [6.5, 10.5], [6.5, 9.5], // Bottom-left up
    [5.5, 8.5], [4.5, 8.5], [3.5, 8.5], [2.5, 8.5], [1.5, 8.5], [0.5, 8.5], // Left bottom
    [0.5, 7.5], // Left center
    [0.5, 6.5]  // Final square before Red entry
];

// Home columns (6 squares per player, index 5 is center/finish)
export const HOME_COLUMNS = {
    0: [[1.5, 7.5], [2.5, 7.5], [3.5, 7.5], [4.5, 7.5], [5.5, 7.5], [7.5, 7.5]], // Red
    1: [[7.5, 1.5], [7.5, 2.5], [7.5, 3.5], [7.5, 4.5], [7.5, 5.5], [7.5, 7.5]], // Green
    2: [[13.5, 7.5], [12.5, 7.5], [11.5, 7.5], [10.5, 7.5], [9.5, 7.5], [7.5, 7.5]], // Yellow
    3: [[7.5, 13.5], [7.5, 12.5], [7.5, 11.5], [7.5, 10.5], [7.5, 9.5], [7.5, 7.5]]  // Blue
};

// Bases (4 positions per player) - centered on circles in the image
export const BASE_COORDS = {
    0: [[1.8, 1.8], [4.2, 1.8], [1.8, 4.2], [4.2, 4.2]], // Red (Top-Left)
    1: [[10.8, 1.8], [13.2, 1.8], [10.8, 4.2], [13.2, 4.2]], // Green (Top-Right)
    2: [[10.8, 10.8], [13.2, 10.8], [10.8, 13.2], [13.2, 13.2]], // Yellow (Bottom-Right)
    3: [[1.8, 10.8], [4.2, 10.8], [1.8, 13.2], [4.2, 13.2]]  // Blue (Bottom-Left)
};

export const getColor = (index) => {
    switch (index) {
        case 0: return '#ff4d4d'; // Red
        case 1: return '#2ecc71'; // Green
        case 2: return '#f1c40f'; // Yellow
        case 3: return '#3498db'; // Blue
        default: return '#fff';
    }
};

export const getTokenCoords = (token, playerIndex) => {
    if (token.state === 'BASE') {
        return BASE_COORDS[playerIndex][token.id];
    }
    if (token.state === 'ACTIVE') {
        return TRACK_COORDS[token.main_track_pos];
    }
    if (token.state === 'HOME_COLUMN') {
        return HOME_COLUMNS[playerIndex][token.home_col_step - 1];
    }
    if (token.state === 'FINISHED') {
        return [7.5, 7.5]; // Center
    }
    return [0, 0];
};

export const getPathCoords = (startPos, roll, playerIndex, isHomeCol) => {
    const coordsPath = [];
    let currentPos = startPos;
    let homeColStarted = isHomeCol;
    
    // Global indices where players turn into home columns
    const homeEntry = [51, 12, 25, 38][playerIndex];

    for (let i = 0; i < roll; i++) {
        if (!homeColStarted) {
            if (currentPos === homeEntry) {
                homeColStarted = true;
                currentPos = 0; 
            } else {
                currentPos = (currentPos + 1) % 52;
            }
        } else {
            currentPos++;
        }

        if (homeColStarted) {
            if (currentPos >= 5) {
                coordsPath.push([7.5, 7.5]); // Home center
                break;
            }
            coordsPath.push(HOME_COLUMNS[playerIndex][currentPos]);
        } else {
            coordsPath.push(TRACK_COORDS[currentPos]);
        }
    }
    return coordsPath;
};
